import { Tag } from "Components";
import { PropertyData } from "../CampaignReport.type";
import { GET_COLOR_BY_SCORE } from "../CampaignReport.constant";
import { TFunction } from "i18next";

const PropertyListItem = ({ propertyData, t }: { propertyData: PropertyData, t: TFunction }) => {
    const { color: resultColor, bg: resultBg } = GET_COLOR_BY_SCORE(propertyData.pass_rate || 0);

    return <div className='list-item property-item'>
        <div className='row'>
            <span className='title'>{propertyData.group_name}</span>
            <Tag className='status-tag' style={{ color: resultColor, background: resultBg }}>
                {`${propertyData.pass_rate}%`}
            </Tag>
        </div>
        <div className='row'>
            <span className='description'><strong>{t('phishingManager.report.table.propertyMobileCard.open')}: </strong>{propertyData.opened_rate}</span>
            <span className='description'><strong>{t('phishingManager.report.table.propertyMobileCard.click')}: </strong>{propertyData.clicked_rate}</span>
        </div>
        <div className='row'>
            <span className='description'><strong>{t('phishingManager.report.table.propertyMobileCard.sent')}: </strong>{propertyData.email_sent_count}</span>
            <span className='description'><strong>{t('phishingManager.report.table.propertyMobileCard.submit')}: </strong>{propertyData.submission_rate}</span>
        </div>
        <div className='row'>
            <span className='description'><strong>{t('phishingManager.report.table.propertyMobileCard.clicked')}: </strong>{propertyData.clicked_link_count}</span>
            <span className='description'><strong>{t('phishingManager.report.table.propertyMobileCard.submitted')}: </strong>{propertyData.submitted_data_count}</span>
        </div>
        <div className='row'>
            <span className='description'><strong>{t('phishingManager.report.table.propertyMobileCard.opened')}: </strong>{propertyData.email_opened_count}</span>
            <span className='description'><strong>{t('phishingManager.report.table.propertyMobileCard.totalUsers')}: </strong>{propertyData.users_count}</span>
        </div>
    </div>
}

export default PropertyListItem;